import { useQuery/*, useQueryClient*/ } from "@tanstack/react-query";
import { useGetAll } from "./crudService";

const endpoint:string = 'ec-dev-stats';

export function useGetAllEcDevStats() {
    return useGetAll({queryKey: [endpoint]});
}
